module.exports = __webpack_public_path__ + "static/img/Record_Vitals_for_a_Patient.a554bd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Record_Vitals_for_a_Patient.jpg
// module id = fXfJ
// module chunks = 7